import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NoFilter from "../../../../DataTable/datatable.nofilter";

export function LRLColumn() {
    return {
        Header: 'LRL',
        accessor: 'min',
        Filter: NoFilter,
        Cell: ({ row, value }: any) => {
            if (row.original.lowerReleaseLimit != null) {
                return (
                    <OverlayTrigger overlay={<Tooltip>Sales limit: {value}</Tooltip>}>
                        <span>{row.original.lowerReleaseLimit}</span>
                    </OverlayTrigger>
                );
            } else {
                return value;
            }
        }
    };
}